var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-container", { staticClass: "px-3 mt-4" }),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.mvms } },
        [
          _c("el-table-column", {
            attrs: { prop: "AssetNo", label: "機台編號", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "機台說明" },
          }),
          _c("el-table-column", {
            attrs: { prop: "client.name", label: "客戶" },
          }),
          _c("el-table-column", {
            attrs: { prop: "locate.name", label: "放置地址" },
          }),
          _c("el-table-column", {
            attrs: { prop: "model.name", label: "型號" },
          }),
          _c("el-table-column", {
            attrs: { prop: "user.name", label: "巡補員" },
          }),
          _c("el-table-column", {
            attrs: { prop: "Status", label: "狀態" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          effect: "dark",
                          type: _vm._f("statusColorFilter")(scope.row.Status),
                        },
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("statusFilter")(scope.row.Status)) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }